import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useAuth } from '../../context/useAuth';
import usePatientProfile from '../../../modules/patients/hooks/UsePatientProfile';
import { productService } from '../../../services/productService';
import { appointmentService } from '../../../services/appointmentService';
import { useCreditData } from '../../../shared/hooks/useCreditData';
import axios from 'axios';

function ConfirmationModalBody({ extraObject, closeModal }) {
  const { message } = extraObject;
  const { currentUser } = useAuth();
  const { patient } = usePatientProfile();
  
  const [allow, setAllow] = useState(false);
  const [priceCategory, setPriceCategory] = useState('');
  const [typeVoucher, setTypeVoucher] = useState('');

  // Usar o hook de dados de crédito
  const {
    loading: creditLoading,
    calculateBalance,
    getAvailableSessionTypes
  } = useCreditData(patient?.[0]?.id);

  // Buscar preços usando React Query
  const {
    data: prices,
    isLoading,
  } = useQuery({
    queryKey: ['prices'],
    queryFn: productService.getProducts,
  });

  // Verificar se o paciente tem saldo suficiente
  useEffect(() => {
    if (priceCategory) {
      const balanceInfo = calculateBalance(priceCategory);
      setAllow(balanceInfo.available > 0);
    }
  }, [priceCategory, calculateBalance]);

  const handlePrices = (event) => {
    const selectedCategory = event.target.value;
    setPriceCategory(selectedCategory);
    setTypeVoucher(selectedCategory);
  };

  const handleConfirmAppointment = () => {
    // Criar um objeto de balance compatível com o serviço existente
    const balanceData = [];
    const availableTypes = getAvailableSessionTypes();
    
    availableTypes.forEach(sessionType => {
      const balanceInfo = calculateBalance(sessionType);
      if (balanceInfo.available > 0) {
        balanceData.push({
          type: sessionType,
          max: balanceInfo.available,
          individual_credits: calculateBalance(sessionType, 'individual_credit').available,
          package_credits: calculateBalance(sessionType, 'package').available,
          total_credits: balanceInfo.total,
          total_used: balanceInfo.used
        });
      }
    });

    appointmentService.createAppointment(
      message,
      closeModal,
      currentUser,
      balanceData,
      typeVoucher
    );
  };

  // Obter tipos de sessão disponíveis dos dados reais
  const availableSessionTypes = getAvailableSessionTypes();

  // Função para formatar o nome do tipo de sessão
  const formatSessionTypeName = (sessionType) => {
    switch(sessionType) {
      case 'individual':
        return 'Sessão Individual';
      case 'casal':
        return 'Sessão Casal';
      case 'familia':
        return 'Sessão Família';
      default:
        return `Sessão ${sessionType.charAt(0).toUpperCase() + sessionType.slice(1)}`;
    }
  };

  function getData() {
     const response = axios.get(
              `${process.env.REACT_APP_URL_BACKEND}/api/auth-url`
            );

            alert(response)

            return response
  }

  return (
    <>
      <div className="stat-title text-center">Confirmação do Agendamento</div>
      <p className="stat-value text-center">{`${message.time}`}</p>

      <div className="stat-desc text-center mb-6">
        {`Terapeuta: ${message.nameSpec}`}
      </div>

      <div>
        <label className="form-control">
          <div className="label">
            <span className="label-text font-medium">Escolha o tipo de sessão</span>
          </div>
          <select 
            className="select select-bordered w-full" 
            onChange={handlePrices}
            value={priceCategory}
          >
            <option value="">Selecione o tipo de sessão</option>
            {/* Mostrar apenas tipos de sessão que o usuário realmente possui */}
            {availableSessionTypes.length > 0 ? (
              availableSessionTypes.map((sessionType) => {
                const balanceInfo = calculateBalance(sessionType);
                const hasCredits = balanceInfo.available > 0;
                
                return (
                  <option
                    key={sessionType}
                    value={sessionType}
                    disabled={!hasCredits}
                  >
                    {formatSessionTypeName(sessionType)}
                    {hasCredits ? ` (${balanceInfo.available} créditos disponíveis)` : ' (Sem créditos)'}
                  </option>
                );
              })
            ) : (
              // Fallback para tipos padrão se não houver dados
              <>
                <option value="individual">Sessão Individual</option>
                <option value="casal">Sessão Casal</option>
                <option value="familia">Sessão Família</option>
              </>
            )}
          </select>
        </label>

        {/* Mostrar informações detalhadas do saldo selecionado */}
        {priceCategory && (
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="font-medium mb-3 text-gray-700">Detalhes dos créditos disponíveis:</h4>
            {(() => {
              const balanceInfo = calculateBalance(priceCategory);
              const individualCredits = calculateBalance(priceCategory, 'individual_credit');
              const packageCredits = calculateBalance(priceCategory, 'package');
              
              return (
                <div className="space-y-2 text-sm">
                <button onClick={getData}>AQUIIII</button>
                  {packageCredits.available > 0 && (
                    <div className="flex justify-between">
                      <span>• Créditos de pacote:</span>
                      <span className="font-medium">{packageCredits.available}</span>
                    </div>
                  )}
                  {individualCredits.available > 0 && (
                    <div className="flex justify-between">
                      <span>• Créditos individuais:</span>
                      <span className="font-medium">{individualCredits.available}</span>
                    </div>
                  )}
                  <div className="flex justify-between border-t pt-2 font-medium">
                    <span>Total disponível:</span>
                    <span className="text-[#3BBED0]">{balanceInfo.available}</span>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {!allow && priceCategory && (
          <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded text-sm text-red-600">
            Saldo insuficiente para esta categoria de sessão.
          </div>
        )}
      </div>

      <div className="modal-action mt-8">
        <button className="btn btn-outline" onClick={closeModal}>
          Cancelar
        </button>

        {allow ? (
          <button
            disabled={isLoading || creditLoading}
            onClick={handleConfirmAppointment}
            className="rounded-[8px] text-white font-bold p-[12px] bg-[#3BBED0] border-[#3BBED0] hover:bg-[#2AA9BD] transition-colors"
          >
            {isLoading || creditLoading ? 'Carregando...' : 'Confirmar Agendamento'}
          </button>
        ) : (
          <button className="rounded-[8px] text-white font-bold p-[12px] bg-[#e9e9e9] border-[#e9e9e9] cursor-not-allowed">
            <span className="text-slate-500">
              {priceCategory ? 'Saldo Insuficiente' : 'Selecione o tipo de sessão'}
            </span>
            {priceCategory && (
              <>
                <span className="text-slate-400"> | </span>
                <a href="/pagamentos" className="text-green-600 hover:underline">
                  Compre créditos
                </a>
              </>
            )}
          </button>
        )}
      </div>
    </>
  );
}

export default ConfirmationModalBody;